import React from "react";
import useFetch from '../API/useFetch';

const matchClosest = (sizes, matchWidth) => {
  const sizesKey = Object.keys(sizes);
  // TODO: match the closest size that is larger than the given width
  console.log(sizesKey);
  // Remove optional chaining - use old syntax
  return (sizes.full && sizes.full.source_url) || sizes.full;
};

const WPImage = ({ url, data, alt, ...props }) => {
  // Only fetch if we have a URL and no data already provided
  const [state, doFetch] = useFetch(url && !data ? url : null, null);

  // Get window innerWidth (be careful, this runs on every render)
  const w = typeof window !== 'undefined' ? window.innerWidth : 0;

  // If data is already provided (passed as prop), use it directly
  if (data) {
    // Remove optional chaining
    const src = (data.sizes && data.sizes.large) || data.source_url || data;
    return <img {...props} src={src} alt={alt || ""} />;
  }

  // If we fetched data successfully, use it
  if (state && state.data && state.data.media_details) {
    const sizes = state.data.media_details.sizes;
    const src = matchClosest(sizes, w);
    const altText = (state.data && state.data.alt_text) || "";
    return <img {...props} src={src} alt={alt || altText} />;
  }

  // Show loading or error state
  if (state && state.isLoading) {
    return <img {...props} src={""} alt="Loading..." />;
  }

  if (state && state.error) {
    console.error("WPImage fetch error:", state.error);
    return <img {...props} src={""} alt={alt || "Error loading image"} />;
  }

  // Default fallback
  return <img {...props} src={""} alt={alt || ""} />;
};

export default WPImage;